import * as yup from 'yup';
export const medicationListSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    medicationName: yup.string().required(),
    medicationDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const problemListSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    problemName: yup.string().required(),
    problemDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const transportationListSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    transportationName: yup.string().required(),
    transportationDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const nutritionListSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    nutritionName: yup.string().required(),
    nutritionDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const psychosocialListSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    psychosocialName: yup.string().required(),
    psychosocialDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const functionalListSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    functionalName: yup.string().required(),
    functionalDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const patientGoalsSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    goal: yup.string().required(),
    metric: yup.string().required(),
    initial: yup.string().required(),
    target: yup.string().required(),
    prognosis: yup.string().required(),
    goalDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const interventionsSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    intervention: yup.string().required(),
    frequency: yup.string().required(),
    interventionDescription: yup.string().nullable(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
export const demographicsSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    carePlanId: yup.number().required().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    isEditable: yup.boolean().required(),
    mrn: yup.string().nullable(),
    primaryDiagnosis: yup.string().nullable(),
    secondaryDiagnosis: yup.string().nullable(),
    providerName: yup.string().nullable(),
    createdAt: yup.date().nullable(),
    updatedAt: yup.date().nullable(),
    deletedAt: yup.date().nullable()
});
